const RatingCircle = ({ value }) => {
    value = Number(value);
    const filledStars = Math.floor(value);
    const halfFilled = value - filledStars === 0.5;
  
    const getCircleColor = (index) => {
      if (index < filledStars) {
        return 'bg-green-500'; // Change this to your desired color for filled stars
      }
      return 'bg-gray-300'; // Change this to your desired color for empty stars
    };
  
    return (
      <div className="flex justify-evenly">
        {Array.from({ length: filledStars }).map((_, index) => (
          <div
            key={index}
            className={`h-3 w-3 rounded-full ${getCircleColor(index)}`}
          />
        ))}
        
        {halfFilled && (
            <>
          <div className="h-3 w-3 rounded-full relative">
            <div
              className={`h-full w-full bg-green-500 rounded-full`}
              style={{ clipPath: 'polygon(0 0, 50% 0, 50% 100%, 0 100%)' }}
            />
            </div>
            <div className="h-3 w-3 rounded-full relative">
            <div
              className={`h-full w-full  rounded-full border-2 border-green-500 -ml-3 `}
              style={{ clipPath: 'polygon(50% 0, 100% 0, 100% 100%, 50% 100%)' }}
            />
          </div></>
        )}
        {Array.from({ length: 5 - filledStars - (halfFilled ? 1 : 0) }).map((_, index) => (
          <div
            key={filledStars + (halfFilled ? 1 : 0) + index}
            className={`h-3 w-3 rounded-full ${getCircleColor(filledStars + (halfFilled ? 1 : 0) + index)}`}
          />
        ))}
      </div>
    );
  };
  
  export default RatingCircle;
  